import { render, staticRenderFns } from "./delete-account.vue?vue&type=template&id=4a94756f&scoped=true&"
import script from "./delete-account.vue?vue&type=script&lang=js&"
export * from "./delete-account.vue?vue&type=script&lang=js&"
import style0 from "./delete-account.vue?vue&type=style&index=0&id=4a94756f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a94756f",
  null
  
)

export default component.exports